import type { ApplicativeImageFinding, ImagePackageFix } from "@/domain/issue"

export interface DockerfileRebuildItem {
  imageName: string
}

export const isDockerfileFix = (fix: ImagePackageFix): boolean =>
  fix.source === "dockerfile" || fix.source === "os_hierarchies"

export const getDockerfileUpdateFixes = (
  findings: ApplicativeImageFinding[]
): ImagePackageFix[] => {
  const seen = new Set<string>()
  const fixes: ImagePackageFix[] = []

  findings.forEach((finding) => {
    finding.remedies
      .filter((fix) => isDockerfileFix(fix) && fix.fixType !== "rebuild")
      .forEach((fix) => {
        const key = [
          fix.packageName,
          fix.fixType,
          fix.version ?? "",
          fix.currentVersion ?? ""
        ].join("|")

        if (!seen.has(key)) {
          seen.add(key)
          fixes.push(fix)
        }
      })
  })

  return fixes
}

export const getDockerfileRebuildImages = (
  findings: ApplicativeImageFinding[]
): DockerfileRebuildItem[] => {
  const seen = new Set<string>()
  const items: DockerfileRebuildItem[] = []

  findings.forEach((finding) => {
    const hasRebuild = finding.remedies.some(
      (fix) => isDockerfileFix(fix) && fix.fixType === "rebuild"
    )

    if (hasRebuild && !seen.has(finding.resource.name)) {
      seen.add(finding.resource.name)
      items.push({ imageName: finding.resource.name })
    }
  })

  return items
}

export const hasDockerfileFixes = (
  findings: ApplicativeImageFinding[]
): boolean =>
  findings.some((f) => f.remedies?.some((fix) => isDockerfileFix(fix)))

export const hasOsHierarchyFixes = (
  findings: ApplicativeImageFinding[]
): boolean =>
  findings.some((f) =>
    f.remedies?.some((fix) => fix.source === "os_hierarchies")
  )
